import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { BusinessService } from '@mpt-fo/common/core/services/business.service';
import { LocalStorageService } from '@mpt-fo/common/core/services/local-storage.service';
import { ScreenManagerService } from '@mpt-fo/common/core/services/screen-manager.service';
import { WizardNavigation } from '@mpt-fo/common/kamona/model/kamonal-model';
import { OtpPhoneSelectorComponent } from '../../otp-phone-selector.component';

@Component({
  selector: 'app-otp-phone-selector-mobile',
  templateUrl: './otp-phone-selector-mobile.component.html',
  styleUrls: ['./otp-phone-selector-mobile.component.scss']
})
export class OtpPhoneSelectorMobileComponent extends OtpPhoneSelectorComponent implements OnInit {

  constructor(screenManager: ScreenManagerService, fb: FormBuilder, router: Router, businessService: BusinessService, localStorage: LocalStorageService) { 
    super(screenManager, fb, router, businessService, localStorage)

  }

  ngOnInit(): void {
    this.loading = true;
    this.initialize();
  }

}
